import React from 'react';
import AutoSaveDropdown from "./AutoSaveDropdown";

const AutoSaveFontDropdown = (props) => <AutoSaveDropdown {...props} options={[
  {value: 'amatic_scbold', textKey: 'font.amatic'},
  {value: 'Arial', textKey: 'font.arial'},
  {value: 'Boogaloo', textKey: 'font.boogaloo'},
  {value: 'Helvetica', textKey: 'font.helvetica'},
  {value: 'impact', textKey: 'font.impact'},
  {value: 'Lato', textKey: 'font.lato'},
  {value: 'Roboto', textKey: 'font.roboto'},
  {value: 'Times New Roman', textKey: 'font.times_new_roman'}
]}/>;

export default AutoSaveFontDropdown;


// WEBPACK FOOTER //
// ./public/components/forms/AutoSaveFormFields/AutoSaveFontDropdown.jsx